import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Live from './views/Live.vue';
import Your from './views/Your.vue';
import Moment from './views/Moment.vue';
import MomentDetail from './views/MomentDetail.vue';
import Prosecco from './views/Prosecco.vue';
import KnowHow from './views/KnowHow.vue';
import Collection from './views/Collection.vue';
import Contacts from './views/Contacts.vue';
import store from './store';

Vue.use(Router);

const routes = [{
  path: '/:lang(en|it)',
  name: 'home',
  component: Home,
  props: {
    color: 'none',
  },
}, {
  path: '/',
  redirect: window.navigator.language.indexOf('it') >= 0 ? '/it' : '/en',
}, {
  path: '/:lang(en|it)/manifesto',
  name: 'live',
  component: Live,
  props: {
    color: 'white',
  },
}, {
  path: '/:lang(en|it)/social',
  name: 'your',
  component: Your,
  props: {
    color: 'white',
  },
}, {
  path: '/:lang(en|it)/whats-new',
  name: 'moment',
  component: Moment,
  props: {
    color: 'white',
  },
}, {
  path: '/:lang(en|it)/whats-new/:slug',
  name: 'moment-detail',
  component: MomentDetail,
  props: {
    color: 'white',
  },
}, {
  path: '/:lang(en|it)/collection/:bottle',
  name: 'prosecco',
  component: Prosecco,
  props: {
    color: 'black',
  },
}, {
  path: '/:lang(en|it)/know-how',
  name: 'know-how',
  component: KnowHow,
}, {
  path: '/:lang(en|it)/collection',
  name: 'collection',
  component: Collection,
  props: {
    color: 'black',
  },
}, {
  path: '/:lang(en|it)/contacts',
  name: 'contacts',
  component: Contacts,
  props: {
    color: 'white',
  },
}];

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (store.state.navigating) return;
  store.commit('SET_NAVIGATING', true);
  if (typeof to.params.lang !== 'undefined') {
    store.commit('SET_LANG', to.params.lang);
    store.commit('SET_COLOR', to.matched[0].props.default.color);
    if (window.ga) {
      window.ga('set', 'page', to.path);
      window.ga('send', 'pageview');
    }
    next();
  } else {
    next(`/${window.navigator.language.indexOf('it') >= 0 ? 'en' : 'en'}`); // ITA is disabled currently
  }
});

export default router;
